class FabCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-track]');
    this.slides = root.querySelectorAll('.fab-carousel__slide');
    this.prev = root.querySelector('[data-prev]');
    this.next = root.querySelector('[data-next]');
    this.dotsWrapper = root.querySelector('[data-dots]');
    this.index = 0;

    this.createDots();
    this.bindEvents();
    this.update();
  }

  createDots() {
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.addEventListener('click', () => {
        this.index = i;
        this.update();
      });
      this.dotsWrapper.appendChild(dot);
    });
  }

  bindEvents() {
    this.prev.addEventListener('click', () => {
      this.index = (this.index - 1 + this.slides.length) % this.slides.length;
      this.update();
    });

    this.next.addEventListener('click', () => {
      this.index = (this.index + 1) % this.slides.length;
      this.update();
    });
  }

  update() {
    this.track.style.transform = `translateX(-${this.index * 100}%)`;

    [...this.dotsWrapper.children].forEach((dot, i) => {
      dot.classList.toggle('active', i === this.index);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-carousel]')
    .forEach(el => new FabCarousel(el));
});
